export class ListMicrosoft365Groups200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<Microsoft365Group>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365Groups200Response.attributeTypeMap;
    }
    constructor() {
    }
}
